document.addEventListener("DOMContentLoaded", function () {
  const giftInput = document.getElementById("gift_message");
  const langIndicator = document.getElementById("lang-indicator");
 
  if (!giftInput) return;


  let saveTimeout = null;
  const storeLocale = window.giftMsgConfig?.storeLocale || 'en';


  // COMPLETE A-Z alphabet mapping
  const alphabetTranslations = {
    he: {
      'a': 'א', 'b': 'ב', 'c': 'ס', 'd': 'ד', 'e': 'ע', 'f': 'ף', 'g': 'ג',
      'h': 'ה', 'i': 'י', 'j': 'ג', 'k': 'כ', 'l': 'ל', 'm': 'ם', 'n': 'ן',
      'o': 'ו', 'p': 'פ', 'q': 'ק', 'r': 'ר', 's': 'ס', 't': 'ת', 'u': 'ו',
      'v': 'ו', 'w': 'ו', 'x': 'כ', 'y': 'י', 'z': 'ז'
    },
    ur: {
      'a': 'ا', 'b': 'ب', 'c': 'سی', 'd': 'ڈ', 'e': 'ے', 'f': 'ف', 'g': 'گ',
      'h': 'ہ', 'i': 'ی', 'j': 'ج', 'k': 'ک', 'l': 'ل', 'm': 'م', 'n': 'ن',
      'o': 'و', 'p': 'پ', 'q': 'ق', 'r': 'ر', 's': 'س', 't': 'ٹ', 'u': 'و',
      'v': 'و', 'w': 'و', 'x': 'کس', 'y': 'ی', 'z': 'ز'
    },
    ar: {
      'a': 'ا', 'b': 'ب', 'c': 'ك', 'd': 'د', 'e': 'ي', 'f': 'ف', 'g': 'ج',
      'h': 'ه', 'i': 'ي', 'j': 'ج', 'k': 'ك', 'l': 'ل', 'm': 'م', 'n': 'ن',
      'o': 'و', 'p': 'ب', 'q': 'ق', 'r': 'ر', 's': 'س', 't': 'ت', 'u': 'و',
      'v': 'و', 'w': 'و', 'x': 'ك', 'y': 'ي', 'z': 'ز'
    }
  };


  function detectLanguage(text) {
    if (!text) return 'en';
    const hebrew = /[\u0590-\u05FF]/;
    const arabicUrdu = /[\u0600-\u06FF\u0750-\u077F]/;
   
    if (hebrew.test(text)) return 'he';
    if (arabicUrdu.test(text)) return storeLocale === 'ar' ? 'ar' : 'ur';
    return 'en';
  }


  function translateCharacterByCharacter(text) {
    if (storeLocale === 'en' || !text || !alphabetTranslations[storeLocale]) return text;
   
    let translated = '';
    for (let i = 0; i < text.length; i++) {
      const char = text[i].toLowerCase();
      if (/[\s\.,!?\-'"()0-9]/.test(char)) {
        translated += char;
      } else if (alphabetTranslations[storeLocale][char]) {
        translated += alphabetTranslations[storeLocale][char];
      } else {
        translated += char;
      }
    }
    return translated;
  }


  function updateIndicator(translatedChars = 0, totalChars = 0) {
    if (totalChars === 0) {
      const langNames = { 'he': 'עברית', 'ur': 'اردو', 'ar': 'العربية', 'en': 'English' };
      langIndicator.textContent = `🆔 ${langNames[storeLocale] || storeLocale}`;
      return;
    }
    const percent = Math.round((translatedChars / totalChars) * 100);
    langIndicator.textContent = `🆔 ${percent}% translated ✨`;
  }


  giftInput.addEventListener("input", function () {
    const originalText = giftInput.value;
    const translatedText = translateCharacterByCharacter(originalText);
   
    const translatedCount = (translatedText.match(/[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F]/) || []).length;
    const totalCount = originalText.replace(/[\s\.,!?\-'"()0-9]/g, '').length;
   
    if (translatedText !== originalText) {
      giftInput.value = translatedText;
      updateIndicator(translatedCount, totalCount);
    } else {
      updateIndicator(0, totalCount);
    }
   
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { gift_message: giftInput.value } })
      }).catch(err => console.error('Save failed:', err));
    }, 800);
  });


  updateIndicator();
});

